module.exports = __webpack_public_path__ + "static/media/m_2.4b0bd8e0.svg";